module.exports = __webpack_public_path__ + "img/ic_arrow_up.811b9348.svg";